// extracted by mini-css-extract-plugin
export default {"cursor":"Star_cursor__hSiuM"};